import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as ModalCloseIcon } from "../../../assets/svg/close-modal.svg";
import { ReactComponent as CrossIcon } from "../../../assets/svg/close.svg";
import { Row, Col } from "react-bootstrap";
// import "../visitor/visitor-create/visitor-create.css";
import DOMPurify from "dompurify";
// import { createPOVApi, getLocationListApi, getPOVDetailsApi, updatePOVApi } from "./setup-api";
import CommonAsyncSelect from "../../common/custom-select";
import { getCustomerApi, getDeptApi, getLocationApi, saveCustomerApi, updateCustomerApi } from "../customers/customer-api";
import "../customers/customer.css";
const CustomerCreateModal = ({ povId, onSuccess, onCancel }) => {
    const apiUrl = process.env.REACT_APP_API_URL;
    const navigate = useNavigate();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [validations, setValidations] = useState({
        code: "",
        name: "",
        email: "",
        contact_number: "",
        locations: "",
        departments: "",
    });
    useEffect(() => {
        if (povId != null && povId !== "") {
            getcustomerDetails();
        }
    }, [povId]);
    const [emailList, setEmailList] = useState([]);
    const [mobileList, setMobileList] = useState([]);

    const handleAddEmail = () => {
        const trimmedEmail = email.trim();

        // Simple email format regex
        const isValidEmail = (email) =>
            /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

        if (!trimmedEmail) {
            setValidations((prev) => ({
                ...prev,
                email: "Email is required",
            }));
            return;
        }

        if (!isValidEmail(trimmedEmail)) {
            setValidations((prev) => ({
                ...prev,
                email: "Invalid email format",
            }));
            return;
        }

        // Clear validation if all is good
        setValidations((prev) => ({
            ...prev,
            email: "",
        }));
        setEmailList((prevList) => [...prevList, trimmedEmail]);
        setEmail("");
    };

    const handleAddMobile = () => {
        const trimmedMobile = contactNo.trim();
        if (!trimmedMobile) return;

        setMobileList((prevList) => [...prevList, trimmedMobile]);
        setcontactNo(""); // clear input
    };

    const handleRemoveEmail = (indexToRemove) => {
        setEmailList((prevList) =>
            prevList.filter((_, index) => index !== indexToRemove)
        );
    };

    const handleRemoveMobile = (indexToRemove) => {
        setMobileList((prevList) =>
            prevList.filter((_, index) => index !== indexToRemove)
        );
    };

    const getcustomerDetails = async () => {
        try {
            const response = await getCustomerApi(povId);
            if (response && response.status === 200 && response.data?.success === true) {
                const customer = response.data.customer;
                setName(customer.name ?? '');
                setCode(customer.code ?? '');

                let emails = [];
                if (Array.isArray(customer.emails)) {
                    emails = customer.emails.filter(e => e && typeof e === 'string');
                } else if (typeof customer.emails === 'string' && customer.emails.trim()) {
                    emails = customer.emails.split(',').map(e => e.trim()).filter(Boolean);
                } else if (customer.email) {
                    emails = [customer.email];
                }
                setEmailList(emails);

                let mobiles = [];
                if (Array.isArray(customer.contact_numbers)) {
                    mobiles = customer.contact_numbers.filter(m => m != null && String(m).trim());
                } else if (Array.isArray(customer.mobile_numbers)) {
                    mobiles = customer.mobile_numbers.filter(m => m != null && String(m).trim());
                } else if (typeof customer.contact_numbers === 'string' && customer.contact_numbers.trim()) {
                    mobiles = customer.contact_numbers.split(',').map(m => m.trim()).filter(Boolean);
                } else if (customer.contact_number) {
                    mobiles = [String(customer.contact_number)];
                } else if (customer.mobile_number) {
                    mobiles = [String(customer.mobile_number)];
                }
                setMobileList(mobiles);

                const locations = Array.isArray(customer.locations)
                    ? customer.locations.map(item => ({
                        value: String(item.value || item.id || item.uuid || ''),
                        label: String(item.label || item.location_name || item.name || '')
                    }))
                    : [];
                setSelectedLocation(locations);

                const depts = Array.isArray(customer.departments)
                    ? customer.departments.map(item => ({
                        value: String(item.value || item.id || item.uuid || ''),
                        label: String(item.label || item.department_name || item.name || '')
                    }))
                    : [];
                setSelectedDept(depts);
            }
        } catch (err) {
            console.error("Error fetching customer details:", err);
        }
    };
    const [locationsOptions, setlocationsOptions] = useState(null);
    const [multipleGatein, setmultipleGatein] = useState(false);
    const [selectedLocation, setSelectedLocation] = useState([]);
    const [selectedDept, setSelectedDept] = useState([]);
    const handleAssignToDropdownChange = (selectedOptions) => {
        setlocationsOptions(selectedOptions);
    };
    const modalStyle = {
        overlay: { position: "fixed", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "rgba(0, 0, 0, 0.5)", opacity: 1, display: "flex", justifyContent: "center", alignItems: "center", zIndex: 1000 },
        modal: { backgroundColor: "#ffffff", borderRadius: "16px", boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)", width: "718px", overflowY: "auto", minHeight: "fit-content" },
    };

    const [loading, setLoading] = useState(false);
    const [code, setCode] = useState("");
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [contactNo, setcontactNo] = useState("");

    const getLocationData = (inputValue, callback) => {
        setTimeout(async () => {
            const response = await getLocationApi(inputValue);
            if (response.status === 200 && response.data?.success === true) {
                const options = response.data.suggestionlist.map((item) => ({
                    value: String(item.value),
                    label: String(item.label),
                }));
                callback(options);
            }
        }, 300);
    };
    const getDepartmentData = (inputValue, callback) => {
        setTimeout(async () => {
            const response = await getDeptApi(inputValue);
            if (response.status === 200 && response.data?.success === true) {
                const options = response.data.suggestionlist.map((item) => ({
                    value: String(item.value),
                    label: String(item.label),
                }));
                callback(options);
            }
        }, 300);
    };

    const handleLocationChange = (selectedOptions) => {
        setSelectedLocation(selectedOptions || []);
    };
    const handleDeptChange = (selectedOptions) => {
        setSelectedDept(selectedOptions || []);
    };
    const saveCustomer = async () => {
        if (!code.trim() || !name.trim()) {
            setValidations(prev => ({
                ...prev,
                code: !code.trim() ? "Code is required" : "",
                name: !name.trim() ? "Customer Name is required" : "",
            }));
            return;
        }

        setIsSubmitting(true);
        try {
            const payload = {
                code: code,
                name: name,
                emails: emailList,
                contact_numbers: mobileList,
                locations: selectedLocation.map(item => item.value),
                departments: selectedDept.map(item => item.value),
            };
            const dataAfterSanitize = {};
            Object.entries(payload).forEach(([key, value]) => {
                if (typeof value === "boolean" || typeof value === "number" || Array.isArray(value)) {
                    dataAfterSanitize[key] = value;
                } else {
                    dataAfterSanitize[key] = DOMPurify.sanitize(value);
                }
            });
            let response;
            if (povId == null || povId === "") {
                response = await saveCustomerApi(dataAfterSanitize);
            } else {
                response = await updateCustomerApi(dataAfterSanitize, povId);
            }

            if (response && response.status === 400 && response.data?.error) {
                const validationTemp = {
                    code: "",
                    name: "",
                    email: "",
                    contact_number: "",
                    locations: "",
                    departments: "",
                };

                Object.entries(response.data.error).forEach(([key, value]) => {
                    validationTemp[key] = Array.isArray(value) && value.length > 0 ? value[0] : (typeof value === 'string' ? value : '');
                });

                setValidations(validationTemp);
            }

            if (response && response.data?.success === true) {
                onSuccess(response.data);
            }
        } catch (err) {
            console.error("Error saving customer:", err);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div style={modalStyle.overlay}>
            <div style={modalStyle.modal}>
                <div style={{ color: "#ffffff" }}>
                    <div className="modal-header style-justify-between">
                        <div className="add-item-modal-title">{povId != null ? "Edit " : "Add "} Customers</div>
                        <ModalCloseIcon style={{ cursor: "pointer" }} onClick={onCancel} />
                    </div>
                    <div style={{ padding: "16px 24px" }}>
                        <Row style={{ width: "670px" }}>
                            <Col xs={12} sm={12} md={6} style={{ marginBottom: "16px" }}>
                                <div className="field-title">
                                    Code<span style={{ color: "#FF4444" }}>*</span>
                                </div>
                                <input type="text" placeholder="Enter here" className="input-field mt-2 w-100" value={code} onChange={(e) => setCode(e.target.value)} />
                                <span className="field-error">{validations.code}</span>
                            </Col>

                            <Col xs={12} sm={12} md={6} style={{ marginBottom: "16px" }}>
                                <div className="field-title">
                                    Customer Name<span style={{ color: "#FF4444" }}>*</span>
                                </div>
                                <input type="text" placeholder="Enter here" className="input-field mt-2 w-100" value={name} onChange={(e) => setName(e.target.value)} />
                                <span className="field-error">{validations.name}</span>
                            </Col>


                            <Col xs={12} sm={12} md={6} style={{ marginBottom: "16px" }}>
                                <div className="field-title">
                                    Location
                                    {/* <span style={{ color: "#FF4444" }}>*</span> */}
                                </div>
                                <CommonAsyncSelect isMulti cacheOptions value={selectedLocation} loadOptions={getLocationData} onChange={handleLocationChange} defaultOptions placeholder="Select locations" />
                                <span className="field-error">{validations.locations}</span>
                            </Col>

                            <Col xs={12} sm={12} md={6} style={{ marginBottom: "16px" }}>
                                <div className="field-title">
                                    Department
                                    {/* <span style={{ color: "#FF4444" }}>*</span> */}
                                </div>
                                <CommonAsyncSelect isMulti cacheOptions value={selectedDept} loadOptions={getDepartmentData} onChange={handleDeptChange} defaultOptions placeholder="Select department" />
                                <span className="field-error">{validations.departments}</span>
                            </Col>
                            <Col xs={12} sm={12} md={6} style={{ marginBottom: "16px" }}>
                                <div className="field-title">
                                    Mobile Number

                                </div>
                                <div className="input-group mt-2">
                                    <input
                                        type="number"
                                        className="form-control input-field"
                                        placeholder="Enter here"
                                        value={contactNo}
                                        onChange={(e) => setcontactNo(e.target.value)}
                                    />
                                    <div
                                        className="custom-btn"
                                        type="button"
                                        onClick={handleAddMobile}
                                    >
                                        Add
                                    </div>

                                </div>
                                <span className="field-error">{validations.contact_number}</span>
                                {mobileList.length > 0 && (
                                    <div className="field-title mt-2">Added Mobile No</div>
                                )}
                                <div className="d-flex flex-wrap gap-2 mt-2">
                                    {mobileList.map((item, index) => (
                                        <div
                                            key={index}
                                            className="d-flex align-items-center"
                                            style={{
                                                backgroundColor: "#f0f0f0",
                                                color: "#333",
                                                padding: "4px 10px",
                                                borderRadius: "16px",
                                                border: "1px solid #ddd",
                                                fontSize: "14px",
                                                lineHeight: "1"
                                            }}
                                        >
                                            <span style={{ marginRight: "8px" }}>{item}</span>
                                            <span
                                                style={{ cursor: "pointer" }}
                                                onClick={() => handleRemoveMobile(index)}
                                            >
                                                <CrossIcon />
                                            </span>
                                        </div>
                                    ))}
                                </div>
                            </Col>

                            <Col xs={12} sm={12} md={6} style={{ marginBottom: "16px" }}>
                                <div className="field-title">
                                    Email

                                </div>
                                <div className="input-group mt-2">
                                    <input
                                        type="text"
                                        className="form-control input-field"
                                        placeholder="Enter here"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                    />

                                    <div
                                        className="custom-btn"
                                        type="button"
                                        onClick={handleAddEmail}
                                    >
                                        Add
                                    </div>


                                </div>


                                <span className="field-error">{validations.email}</span>
                                {emailList.length > 0 && (
                                    <div className="field-title mt-2">Added Emails</div>
                                )}

                                <div className="d-flex flex-wrap gap-2 mt-2">
                                    {emailList.map((item, index) => (
                                        <div
                                            key={index}
                                            className="d-flex align-items-center"
                                            style={{
                                                backgroundColor: "#f0f0f0",
                                                color: "#333",
                                                padding: "4px 10px",
                                                borderRadius: "16px",
                                                border: "1px solid #ddd",
                                                fontSize: "14px",
                                                lineHeight: "1"
                                            }}
                                        >
                                            <span style={{ marginRight: "8px" }}>{item}</span>
                                            <span
                                                style={{ cursor: "pointer" }}
                                                onClick={() => handleRemoveEmail(index)}
                                            >
                                                <CrossIcon />
                                            </span>
                                        </div>
                                    ))}
                                </div>
                            </Col>
                        </Row>

                        <Row className="mt-3" style={{ width: "670px" }}>
                            <div className="style-justify-end" style={{ gap: "8px" }}>
                                <div
                                    onClick={!isSubmitting ? onCancel : null}
                                    className="cancel-modal-btn style-justify-center"
                                    style={{ cursor: isSubmitting ? "not-allowed" : "pointer" }}
                                >
                                    Cancel
                                </div>
                                <div
                                    className="save-modal-btn style-justify-center"
                                    onClick={!isSubmitting ? () => saveCustomer() : null}
                                    style={{
                                        cursor: isSubmitting ? "not-allowed" : "pointer",
                                        opacity: isSubmitting ? 0.7 : 1,
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px",
                                    }}
                                >
                                    {isSubmitting && (
                                        <div
                                            className="spinner-border spinner-border-sm text-light"
                                            role="status"
                                            style={{ width: "14px", height: "14px" }}
                                        ></div>
                                    )}
                                    {isSubmitting ? (povId != null ? "Updating..." : "Saving...") : (povId != null ? "Update" : "Save")}
                                </div>
                            </div>
                        </Row>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CustomerCreateModal;
